import React, { useMemo} from "react";
import {
    Button,
    useToastController,
    DialogContent,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogTrigger,
    DialogSurface,
    DialogBody } from "@fluentui/react-components";
import TooltipWatcherWidget from "../TooltipWatcherWidget";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import { addDays, format } from "date-fns";
// import {handeDataChange} from './WeekSelector'
import {previousMonday, startOfWeek   } from "date-fns";
import {AddNewTimecode} from '../../services/TimesheetDataService';
import {GetA23WeekTimeEntries, SetTimeEntryDetails} from '../../services/apiService';

import { showErrorToast,showSuccessToast, TOASTER_ID } from "../../services/toastUtils";

export default function PrevButton(props){

    const checkDay = (dateString, targetDay) => {
        const date = new Date(dateString);
        const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date);
        return String(dayName).toLowerCase().substring(0,3) === String(targetDay).toLowerCase().substring(0,3);
    };
    const {currentWeekStart, startLoad, endLoad, useStyles, isDesktop, isTimesheetSubmitted, lockedMonths} = useGlobalStatus();
    const styles = useStyles();
    const timesheetData = props.timesheetData;
    const prevWeekTimesheetData= props.prevWeekTimesheetData;

    const { dispatchToast } = useToastController(TOASTER_ID);
    const targetDay = props.selectedDay;
    const lastWeekStart = previousMonday(currentWeekStart);
    const [open, setOpen] = React.useState(false);

 

    const updateTimeSheet = async (change, copyAllEntries) => {
        startLoad();
        let newTimeSheetData = []
        if(change === "day"){


            // This goes through a copy of the time sheet data and then edits the entry days so  and then copies it to newtimesheet data
            // You must edit entry days to have it display it seems, not time entries
            // Week works similar but works on data from the previous week rather than the current one 
            const yesterdayDate = new Date(targetDay);
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);

            for (const client of timesheetData) {
                const projects = [];

                for (const project of (client?.projects || [])) {
                    const budgets = [];

                    for (const budget of (project?.budgets || [])) {
                        const timecodes = [];

                        for (const timecode of (budget?.timecodes || [])) {

                            const entryDays = timecode.entryDays || [];
                            const todayData = entryDays.find(day => checkDay(day.date, targetDay));
                            const yesterDayData = entryDays.find(day => checkDay(day.date, yesterdayDate));
                            const updatedDays = [];


                            for (const currentDay of entryDays) {
                                let dayToPush = currentDay;
                                if (checkDay(currentDay.date, targetDay)) {
                                    
                                    // If the previous day isnt locked
                                    // And has an entry
                                    // and has any data in it it can be used to update the current day
                                    const canUpdate = yesterDayData &&
                                        yesterDayData.entries?.length > 0 &&
                                        todayData.status === "empty"
                                    if (canUpdate) {

                                        const dateObj = new Date(yesterDayData.date);
                                        let date = addDays(dateObj, 1);

                                        date = format(date, "yyyy-MM-dd HH:mm:ss");

                                        const minimalDetails = yesterDayData.entries.map(details => ({
                                            timeEntryDetailId: 0,
                                            start: details.start,
                                            end: details.end,
                                            break: details.break,
                                            comments: details.comments
                                        }));

                                        const newIds = [];
                                        try{
                                            for (const detail of minimalDetails) {
                                                const id = await SetTimeEntryDetails(
                                                    timecode.taskId,
                                                    date,
                                                    detail,
                                                    false
                                                );
                                                newIds.push(id);
                                            }
                                            showSuccessToast(dispatchToast, "Successfully copied entries");
                                        }
                                        catch{
                                            showErrorToast(dispatchToast, "Failed to copy entries");
                                            endLoad();
                                            return;
                                        }
                                        
                                    // Create a new day object for day entrys for the ui 
                                        dayToPush = {
                                            ...yesterDayData,
                                            date: targetDay,
                                            status: "open",
                                            isReviewed: false,
                                            casualMonthLocked: false,
                                            entries: yesterDayData.entries.map((ent, index) => ({
                                                ...ent,
                                                timeEntryDetailId: newIds[index],
                                                id: newIds[index]
                                            }))
                                        };
                                    }

                                }
                                  // Slowly add everything back into new time sheet
                                updatedDays.push(dayToPush);
                            }
                            timecodes.push({ ...timecode, entryDays: updatedDays });
                        }
                        budgets.push({ ...budget, timecodes });
                    }
                    projects.push({ ...project, budgets });
                }
                newTimeSheetData.push({ ...client, projects });
            }

        props.setTimesheetData(newTimeSheetData);



        }
        else if(change === "week"){


            let updatedTimesheetData = prevWeekTimesheetData || [];
            // Updating entries for the week

            for (const client of updatedTimesheetData) {
                const projects = [];

                for (const project of (client?.projects || [])) {
                    const budgets = [];

                    for (const budget of (project?.budgets || [])) {
                        const timecodes = [];

                        for (const timecode of (budget?.timecodes || [])) {
                            const entryDays = timecode.entryDays || [];
                            const updatedDays = [];
                                

                            for (const day of entryDays) {
                                // default that its what ever the current day is (usually it wil be empty)
                                let dayToPush = day;
                                let minimalDetail;

                                const dateObj = new Date(day.date);
                                let date = addDays(dateObj, 7);
                                date = format(date, "yyyy-MM-dd HH:mm:ss");

                                if(copyAllEntries === false){
                                    dayToPush = {
                                        ...day,
                                        date: date,
                                        status: "empty",
                                        totalMinutes: 0,
                                        isReviewed: false,
                                        casualMonthLocked: false,
                                        entries: []
                                    };
                                }
                                // Get the details needed for creating a new time entry
                                else if (day.entries.length > 0){
                                    for(const details of day.entries){
                                        minimalDetail = {
                                            timeEntryDetailId: 0, 
                                            start: details.start,  
                                            end: details.end,      
                                            break: details.break,            
                                            comments: details.comments
                                        };
                                    }
                                    let newId = 0;
                                    if(minimalDetail){
                                        try{
                                                newId = await SetTimeEntryDetails(
                                                timecode.taskId,
                                                date,
                                                minimalDetail,
                                                false
                                            );
                                            showSuccessToast(dispatchToast, "Successfully updated the weeks entries");
                                            
                                        }
                                        catch{
                                            showErrorToast(dispatchToast, "Failed to copy the previous weeks entries");
                                            endLoad();
                                            return;
                                        }
                                    }


                                    // Create a new day object for day entrys for the ui 
                                    dayToPush = {
                                            ...day,
                                            date: date,
                                            status: "open",
                                            isReviewed: false,
                                            casualMonthLocked: false,
                                            entries: day.entries.map(ent => ({
                                                ...ent,
                                                timeEntryDetailId: newId,
                                                id: newId
                                            }))
                                    };

                                }
                                else{
                                    // default day
                                    dayToPush = {
                                        ...day
                                    }
                                }
                                //  add everything back into new time sheet
                                updatedDays.push(dayToPush);
                            }
                            timecodes.push({ ...timecode, entryDays: updatedDays });
                        }
                        budgets.push({ ...budget, timecodes });
                    }
                    projects.push({ ...project, budgets });
                }
                newTimeSheetData.push({ ...client, projects });
            }

            props.setTimesheetData(newTimeSheetData);

        }
        endLoad();
    }

    const isDayPopulated = useMemo(() => {
        if(props.changeAmount =="week"){
            // get the current week and check if there is any entry days entries
            const weekEntries = timesheetData.some(client => 
                (client.projects || []).some(project => 
                    (project.budgets || []).some(budget => 
                        (budget.timecodes || []).some(tc => (tc.entryDays || []).length > 0)
                    )
                )
            );
 
            // Check the previous week and check if there is any entry days entries
            const prevWeekEntries = prevWeekTimesheetData.some(client => 
                (client.projects || []).some(project => 
                    (project.budgets || []).some(budget => 
                        (budget.timecodes || []).some(tc => (tc.entryDays || []).length > 0)
                    )
                )
            );

            return !weekEntries && prevWeekEntries;
        }
        else{
            // If its monday  dont copy previous
            if (targetDay.getDay() === 1) return false;
            let todayHasData = false;
            let yesterdayHasData = false;
            let todayLocked = false;

                           
            const currentMonth = `${targetDay.getFullYear()}-${String(targetDay.getMonth() + 1).padStart(2, '0')}`;
            const isMonthlyLocked = lockedMonths.has(currentMonth); 

            const yesterdayDate = new Date(targetDay);
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);

            if (isMonthlyLocked) return false;

            // Main loop to help an early return
            mainLoop: for (const client of timesheetData) {
                for (const project of (client.projects || [])) {
                    for (const budget of (project.budgets || [])) {
                        if (targetDay > new Date(project.projectEndDate)) {
                            return false;
                        }

                        for (const timecode of (budget.timecodes || [])) {

                            const timeEntries = timecode.timeEntries || [];
                            const entryDays = timecode.entryDays || [];
                            
                            // Is the day closed?
                            if(timeEntries.some(day => (day.status === "closed" || day.casualMonthLocked === true) && checkDay(day.date, targetDay))){
                                todayLocked = true;
                                return false;
                            }

                            yesterdayHasData ||= entryDays.some(day => day.entries?.length > 0 && checkDay(day.date, yesterdayDate));
                            todayHasData ||= entryDays.some(day => day.entries?.length > 0 && checkDay(day.date, targetDay));

                            // THE MAGIC EXIT:
                            if (yesterdayHasData && todayHasData) {
                                break mainLoop; // Stops EVERY loop immediately
                            }
                        }
                    }
                }
            }
            // No data today, yesterday has data   
            return !todayHasData && yesterdayHasData;
        }
    }, [timesheetData, targetDay, props.changeAmount]);

    const getDynamicMessage = () => {
        // If it's week mode, just return "Week"
        if (props.changeAmount === "week") return "Copy Last Week";
        // The day we are currently looking at (e.g., Thursday)

        // The day we are copying FROM (e.g., Wednesday)
        const prevDate = new Date(targetDay);
        prevDate.setDate(prevDate.getDate() - 1);

        const currentDayName = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(targetDay);
        const prevDayName = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(prevDate);

        const returnMessage = isDesktop 
            ?  `Copy ${prevDayName} ` 
            :  `Copy ${prevDayName} to ${currentDayName}`
        
        return returnMessage

    };

    const dynamicMessage = getDynamicMessage();

    return(
        <>
        {isDayPopulated && !isTimesheetSubmitted  ? (
            <>

             {props.changeAmount == "week" ? (
                    
                    <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
                        <TooltipWatcherWidget text={`Click to add your previous ${props.changeAmount}`}  direction="above-top" style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            width: '100%' ,
                            }}>
                        <DialogTrigger disableButtonEnhancement>
                            <Button 
                            className={styles.buttonPrimary}
                            style={{ fontSize: 13,display: 'flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center',
                                    width: '100%',  marginBottom:'1rem' }}
                            >
                                Copy Prev Week
                            </Button>
                        </DialogTrigger>
                        </TooltipWatcherWidget>

                        <DialogSurface>
                            <DialogBody>
                                <DialogTitle>
                                    Copy previous week's timesheet
                                </DialogTitle>
                                <DialogContent>
                                   Choose how entries should be copied into the current week. 
                                   You can include full time entries or only time codes.
                                </DialogContent>
                                <DialogActions>
                                    <Button className={styles.buttonPrimary} onClick={() => { 
                                        updateTimeSheet(props.changeAmount, true)
                                        setOpen(false);
                                    }} style={{ fontSize: 13,display: 'flex',
                                        justifyContent: 'center', 
                                        alignItems: 'center',
                                        width: '100%',  marginBottom:'1rem', whiteSpace: 'nowrap' }}>
                                            Copy with Entries
                                    </Button>
                                    <Button className={styles.buttonPrimary} onClick={() => { 
                                        updateTimeSheet(props.changeAmount, false)
                                        setOpen(false);
                                    }} style={{ fontSize: 13,display: 'flex',                                         
                                        justifyContent: 'center', 
                                        alignItems: 'center',
                                        width: '100%',  marginBottom:'1rem', whiteSpace: 'nowrap' }}>
                                            Timecodes Only
                                    </Button>
                                    <Button className={styles.buttonPrimary} onClick={() => setOpen(false)} style={{ fontSize: 13,display: 'flex', 
                                        justifyContent: 'center', 
                                        alignItems: 'center',
                                        width: '100%',  marginBottom:'1rem', whiteSpace: 'nowrap' }}>
                                            Cancel
                                    </Button>
                                </DialogActions>
                            </DialogBody>
                        </DialogSurface>
                    </Dialog>
             ) : ( 
                <TooltipWatcherWidget text={`Click to add your previous ${props.changeAmount}`}  direction="above-top" style={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center',
                                width: '100%' ,
                                }}>
                <Button className={styles.buttonPrimary} onClick={() => updateTimeSheet(props.changeAmount, false)} style={{ fontSize: 13,display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    width: '100%',  marginBottom:'0.67rem' }}>
                        {dynamicMessage}
                </Button>
                </TooltipWatcherWidget>
            )}



                </>
            ) : null }
        </>
    )
}
